import React, { useContext } from 'react';
import Link from 'next/link';
import Image from 'components/Layout/Module/Image';
import { StyleContext } from 'utils/context/StyleContextProvider';
import Text from 'components/Tailwind/Module/Text';
import classNames from 'classnames';
import { Byline } from '@viome/vnxt-nucleus';
import { useContentfulInspectorMode } from "@contentful/live-preview/react";

export default function BlogHeader({ blog }) {
    const inspectorProps = useContentfulInspectorMode(),
        data = blog || {},
        {
            category,
            categories,
            title,
            authors,
            featuredImage,
            hideTopFeaturedImage,
            duration,
            notice,
            entryId = '',
        } = data,
        styles = useContext(StyleContext),
        blogCategory = (categories && categories[0]) || category,
        categoryTitle = blogCategory?.title || 'N/A',
        categorySlug = blogCategory?.slug || null;

    return (
        <>
            <div className={classNames(styles.top, 'pt-10')}>
                {notice && (
                    <div className={classNames(styles.notice, 'mb-5')}>
                        <Text
                            data={{
                                body: notice,
                                style: 'Left Aligned',
                            }}
                            {...inspectorProps({
                                entryId,
                                fieldId: 'notice',
                            })}
                        />
                    </div>
                )}
                <Link
                    href={`/blog/category/${categorySlug}`}
                    {...inspectorProps({
                            entryId,
                            fieldId: 'category',
                        })}
                    className={styles.category}
                >
                    {categoryTitle}
                </Link>
                <h1 {...inspectorProps({
                    entryId,
                    fieldId: 'title',
                    })}
                >
                    {title}
                </h1>
                <span
                    {...inspectorProps({
                        entryId,
                        fieldId: 'authors',
                    })}>
                    <Byline authors={authors} duration={duration}  />
                </span>
            </div>
            {!hideTopFeaturedImage && featuredImage && (
                <div className="my-8 mx-auto lg:my-12"
                     {...inspectorProps({
                        entryId,
                        fieldId: 'featuredImage',
                    })}
                >
                    <Image
                        data={featuredImage}
                        options={{ layout: 'responsive' }}
                    />
                </div>
            )}
        </>
    );
}
